import { wsService } from "./wsService";

import sections from "@/constants/sections";

const section = sections.SECTION_FOLDERS;

function filter(param = { enable: true }) {
  return wsService.make_post_request(section + "/list", param);
}

function create(param = {}) {
  return wsService.make_post_request(section + "/create", param);
}

function update(param = {}) {
  return wsService.make_put_request(section + "/update", param);
}

function remove(param = {}) {
  return wsService.make_delete_request(section + "/delete", param);
}
function getFoldersByLegajo(param = {}) {
  return wsService.make_post_request(section + "/folders-by-legajo", param);
}
function uploadDocument(formData) {
  return wsService.make_post_request(section + "/files-by-legajo", formData);
}

function deleteFile(formData) {
  return wsService.make_post_request(section + "/delete-file", formData);
}

export const folderService = {
  section,
  filter,
  remove,
  create,
  update,
  getFoldersByLegajo,
  uploadDocument,
  deleteFile
};
